/*! predictive-search.js — Live search, hårdt scopet til #search-modal */
(function () {
  var modal = document.getElementById('search-modal');
  if (!modal) return;

  var form  = modal.querySelector('form[role="search"]');
  if (!form) return;

  var input = form.querySelector('input[name="q"]');
  if (!input) return;

  // container vi opdaterer (læg den ind i modal’en – se markup-noten nedenfor)
  var outlet = modal.querySelector('[data-predictive-outlet]');
  if (!outlet) {
    outlet = document.createElement('div');
    outlet.setAttribute('data-predictive-outlet', '');
    form.parentNode.appendChild(outlet);
  }

  // Debounce
  var t = null;
  function debounce(fn, ms){ return function(){ clearTimeout(t); var a=arguments; t=setTimeout(function(){ fn.apply(null,a); }, ms||180); }; }

  function urlFor(q){
    var base = '/search';
    var params = new URLSearchParams();
    params.set('view', 'predictive-grid');     // ← vores layout-none view
    params.set('q', q);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    return base + '?' + params.toString();
  }

  function setHTML(html){
    // hård scope: fjern evt. scripts fra responsen (burde ikke komme, men safe)
    outlet.innerHTML = html.replace(/<script[\s\S]*?<\/script>/gi,'');
  }

  var lastQ = '';

  var run = debounce(function(){
    var q = (input.value || '').trim();
    if (q.length < 2) { setHTML(''); lastQ = q; return; }
    if (q === lastQ) return;

    fetch(urlFor(q), { headers:{'X-Requested-With':'XMLHttpRequest'} })
      .then(function(res){ return res.text(); })
      .then(function(html){ setHTML(html); lastQ = q; })
      .catch(function(){ /* ignorer netværksfejl stille */ });
  }, 220);

  // Input events
  input.addEventListener('input', run);
  input.addEventListener('focus', run);

  // Ryd resultater når modal lukkes (scopet til modalens egen close-knap)
  modal.addEventListener('click', function(e){
    if (e.target.closest('[data-modal-close]')) { setHTML(''); lastQ=''; }
  });

  // Når modal åbnes via temaets mekanik: fokusér input
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-modal-toggle="#search-modal"], a[href="#search-modal"]')) {
      requestAnimationFrame(function(){ input && input.focus(); });
    }
  }, true);
})();

(function(){
  var modal  = document.getElementById('search-modal');
  if (!modal) return;
  var outlet = modal.querySelector('[data-predictive-outlet]');
  var input  = modal.querySelector('input[name="q"]');
  if (!outlet || !input) return;

  // Brug denne i stedet for outlet.innerHTML = ...
  window.__setPredictiveResults = function(html){
    outlet.innerHTML = String(html).replace(/<script[\s\S]*?<\/script>/gi, '');
    var has = outlet.querySelector('.predictive-grid, .predictive-empty');
    modal.classList.toggle('has-results', !!has && (input.value||'').trim().length >= 2);
  };

  // når der ryddes/tømmes søgning
  input.addEventListener('input', function(){
    if ((input.value||'').trim().length < 2){
      outlet.innerHTML = '';
      modal.classList.remove('has-results');
    }
  });
})();

(function () {
  const modal   = document.getElementById('search-modal');
  if (!modal) return;

  const inner   = modal.querySelector('.inner');
  const form    = modal.querySelector('.inline-mini-form') || modal.querySelector('form');
  const outlet  = modal.querySelector('[data-predictive-outlet]');
  const nav     = document.getElementById('site-control');

  function navH() { return nav ? nav.clientHeight : 0; }

  function capToViewport(px) {
    const max = Math.max(0, window.innerHeight - navH());
    return Math.min(px, max);
  }

  function measureAndSetHeight() {
    // Base height = just the search bar when there are no results
    const base = (form?.offsetHeight || 0) + 2*(parseInt(getComputedStyle(inner).getPropertyValue('--sg-inner-pad')) || 20);

    // If result outlet has content, include it
    let desired = base;
    if (outlet && outlet.children.length > 0) {
      desired = base + outlet.scrollHeight;
    }

    // Cap by viewport (so we never exceed the window)
    desired = capToViewport(desired);

    // Final: never smaller than the header height
    desired = Math.max(desired, navH());

    modal.style.setProperty('--sg-height', desired + 'px');
  }

  // Watch for results appearing/disappearing
  if (outlet) {
    const mo = new MutationObserver(measureAndSetHeight);
    mo.observe(outlet, { childList: true, subtree: false });
  }

  // Recalculate on resize / orientation change / when the header changes height
  window.addEventListener('resize', measureAndSetHeight, { passive: true });
  window.addEventListener('orientationchange', measureAndSetHeight, { passive: true });

  // Also measure shortly after open (if your theme toggles visibility)
  document.addEventListener('click', (e) => {
    const t = e.target.closest('a[href="#search-modal"], [data-open-search]');
    if (t) {
      requestAnimationFrame(() => {
        // allow DOM to paint, then measure
        setTimeout(measureAndSetHeight, 16);
      });
    }
  });

  // Initial measure (covers the “no results yet” case)
  measureAndSetHeight();
})();